import { toProxiedImageUrl } from '@/lib/imageOptimizer';

// CATEGORY IMAGES: Use optimized AVIF format URLs from Supabase
const categoryImages = {
  'feed': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/animal%20feed.avif',
  'health': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Animal%20health%20and%20medication.avif',
  'pet': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Pet%20supplies.avif',
  'livestock': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Livestock%20management.avif',
  'horse': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Horse%20tack%20and%20grooming.avif',
  'garden': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Gardening%20and%20crop%20supplies.avif',
  'hardware': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/farm%20hardware%20and%20tools.avif',
  'pest': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Pest%20and%20wildlife%20control.avif',
  'building': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Building%20and%20maintenance.avif',
  'clothing': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Clothing%20and%20protective%20gear.avif',
  'seasonal': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Miscellaneous.avif',
  'default': 'https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Miscellaneous.avif'
};

export const getCategoryImage = (categoryName: string) => {
  const name = categoryName.toLowerCase();
  
  if (name.includes('feed') || name.includes('animal feed')) {
    return categoryImages.feed;
  }
  if (name.includes('health') || name.includes('medication')) {
    return categoryImages.health;
  }
  if (name.includes('pet') || name.includes('dog') || name.includes('cat')) {
    return categoryImages.pet;
  }
  if (name.includes('livestock') || name.includes('cattle') || name.includes('sheep')) {
    return categoryImages.livestock;
  }
  if (name.includes('horse') || name.includes('tack') || name.includes('grooming')) {
    return categoryImages.horse;
  }
  if (name.includes('garden') || name.includes('seed') || name.includes('plant')) {
    return categoryImages.garden;
  }
  if (name.includes('hardware') || name.includes('tool') || name.includes('fence')) {
    return categoryImages.hardware;
  }
  if (name.includes('pest') || name.includes('control') || name.includes('insect')) {
    return categoryImages.pest;
  }
  if (name.includes('building') || name.includes('paint') || name.includes('maintenance')) {
    return categoryImages.building;
  }
  if (name.includes('clothing') || name.includes('protective') || name.includes('workwear')) {
    return categoryImages.clothing;
  }
  if (name.includes('seasonal') || name.includes('special')) {
    return categoryImages.seasonal;
  }
  
  return categoryImages.default;
};

export const transformCategories = (categories: any[], getCategoryImage: (name: string) => string, products?: any[], categoryProductCounts?: Record<string, number>) => {
  return categories.map(category => {
    // PERFORMANCE FIX: Use efficient product counting
    // undefined = counts not loaded yet (e.g. static prerender, or before the idle-deferred
    // RPC returns) — CategoryCard renders a blank line instead of a misleading "0 products".
    const categoryProductCount = categoryProductCounts ? 
      (categoryProductCounts[category.id] || 0) : 
      (products ? products.filter(p => p.category_id === category.id).length : undefined);

    return {
      id: category.id,
      name: category.name,
      slug: category.name.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and'),
      description: category.description || '',
      imageUrl: toProxiedImageUrl(category.image_url || getCategoryImage(category.name)),
      productCount: categoryProductCount,
      subcategories: products ? (category.product_subcategories || []).map(sub => ({
        id: sub.id,
        name: sub.name,
        slug: sub.name.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and'),
        productCount: products.filter(p => p.subcategory_id === sub.id).length
      })) : [] // Empty on homepage
    };
  });
};